__turbopack_context__.v({
  "header": "HeaderComponent-module-scss-module__hrzY2W__header",
  "header-small": "HeaderComponent-module-scss-module__hrzY2W__header-small",
  "hide-mobile": "HeaderComponent-module-scss-module__hrzY2W__hide-mobile",
  "section": "HeaderComponent-module-scss-module__hrzY2W__section",
  "stepper-wrapper": "HeaderComponent-module-scss-module__hrzY2W__stepper-wrapper",
  "stepper-wrapper-hidden": "HeaderComponent-module-scss-module__hrzY2W__stepper-wrapper-hidden",
  "text": "HeaderComponent-module-scss-module__hrzY2W__text",
});
